/* eslint-disable indent */

import styled, { css } from 'styled-components';
import {
    Button,
    Icon,
    token,
    spaceMixin,
    Spacer,
    TooltipPopper,
    TriggerText,
    mediaMixin,
    Flex,
} from '@zillow/constellation';

import InteractiveCard from 'app/shared/components/InteractiveCard';

const defaultImageWidth = '144px';

const defaultCardLayoutStyles = css`
    flex-direction: column;

    .ConnectedLeaseCard-LeaseInformation {
        order: 1;
    }

    .ConnectedLeaseCard-LeaseThumbnail {
        order: 2;
        margin-right: 0px;
    }

    .ConnectedLeaseCard-CTAs {
        order: 3;
    }
`;

const tabletSingleCardLayoutStyles = css`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .ConnectedLeaseCard-LeaseThumbnail {
        order: 1;
        margin-right: ${spaceMixin('sm')}
    }

    .ConnectedLeaseCard-LeaseInformation {
        order: 2;
        flex: 1 1 auto;
    }

    .ConnectedLeaseCard-CTAs {
        order: 3;
    }
`;

const tabletMultipleCardLayoutStyles = css`
    flex-direction: column;
    align-items: initial;
    justify-content: flex-end;
`;

export const StyledFullCard = styled(InteractiveCard)`
    display: flex;
    width: 100%;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
    border-radius: 4px;

    .ConnectedLeaseCard-LeaseInformation {
        white-space: nowrap;
    }

    ${mediaMixin('xs_eq', defaultCardLayoutStyles)}

    ${mediaMixin('sm_eq', defaultCardLayoutStyles)}

    ${mediaMixin('md_eq', css`
        ${props => (props.isMultipleLeases ? tabletMultipleCardLayoutStyles : tabletSingleCardLayoutStyles)}
    `)}

    ${mediaMixin('lg', defaultCardLayoutStyles)}
`;

export const StyledSpacer = styled(Spacer)`
    margin-bottom: ${spaceMixin('xs')};

    ${mediaMixin('xl', css`
    ${props => !props.isMultipleLeases &&
        css`
            margin-bottom: 0;
            margin-right: 8px;
        `
        }
    `)}
`;

export const StyledFlex = styled(Flex)`
    flex-direction: column;

    ${mediaMixin('xl', css`
       flex-direction: row;
    `)}
`;
export const StyledDesktopOnlyDiv = styled(Spacer)`
    display: none;
    background-color: ${token('colors.gray200')};
    text-align: center;
    overflow: hidden;
    height: 156px;
    border-radius: ${spaceMixin(0.5)};

    ${mediaMixin('md', css`
        ${props => !props.isMultipleLeases &&
            css`
                display: block;
                height: 130px;
                width: 140px;
            `
        }
    `)}

    ${mediaMixin('lg', css`
        display: block;
        ${props => props.isMultipleLeases && css`
            display: none;
        `}
        width: auto;
        height: 156px;
    `)}

    .LeasePreview, .LeasePreviewPlaceholder {
        width: ${defaultImageWidth};
        margin-top: ${spaceMixin('sm')};
        background-color: ${token('colors.gray200')};

        ${mediaMixin('md', css`
            width: 108px;
        `)}
        ${mediaMixin('lg', css`
            width: ${defaultImageWidth};
        `)}
    }

    .LeasePreview {
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
    }
`;


export const StyledIconButton = styled(Button)`
    /*
     * Override default Button > Icon spacing
     * https://zbrt.atl.zillow.net/browse/CDS-602
    **/
    & > ${Icon} {
        margin-top: 0px;
    }
`;

export const StyledTooltipPopper = styled(TooltipPopper)`
    vertical-align: baseline;
`;

export const StyledTriggerText = styled(TriggerText)`
    border: 0;
`;
